import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private _backendUrl = environment.backendUrl;
  private _httpClient = inject(HttpClient);

  private _banners: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _sections: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _categoriesWorkOfArt: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _worksOfArt: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _artists: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _categoriesArtists: ReplaySubject<any> = new ReplaySubject<any>(1);
  private _ondemands: ReplaySubject<any> = new ReplaySubject<any>(1);

  private _configs: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private _sponsors: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------
  get banners$() {
    return this._banners.asObservable();
  }
  get sections$() {
    return this._sections.asObservable();
  }
  get categoriesWorkOfArt$() {
    return this._categoriesWorkOfArt.asObservable();
  }
  get worksOfArt$() {
    return this._worksOfArt.asObservable();
  }
  get artists$() {
    return this._artists.asObservable();
  }
  get categoriesArtist$() {
    return this._categoriesArtists.asObservable();
  }
  get onDemand$() {
    return this._ondemands.asObservable();
  }

  get configs$() {
    return this._configs.asObservable();
  }
  get configs() {
    return this._configs.getValue();
  }

  get sponsors$() {
    return this._sponsors.asObservable();
  }

  get sponsors() {
    return this._sponsors.getValue();
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Constructor
  // -----------------------------------------------------------------------------------------------------
  constructor() {
    this._banners.next([]);
    this._sections.next([]);
    this._categoriesWorkOfArt.next([]);
    this._worksOfArt.next([]);
    this._artists.next([]);
    this._categoriesArtists.next([]);
    this._ondemands.next([]);
    this._configs.next({});
    this._sponsors.next([]);
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  get(): Observable<any> {
    return this._httpClient.get(`${this._backendUrl}client/home`).pipe(
      tap((response: any) => {
        this._banners.next(response.payload.banners);
        this._sections.next(response.payload.sections);
        this._categoriesWorkOfArt.next(response.payload.categoriesWorkOfArt);
        this._worksOfArt.next(response.payload.worksOfArt);
        this._artists.next(response.payload.artists);
        this._categoriesArtists.next(response.payload.categoriesArtists);
        this._ondemands.next(response.payload.ondemands);
        this._configs.next(response.payload.configs);
        this._sponsors.next(response.payload.sponsors);
      })
    );
  }
}
